module.exports = __webpack_public_path__ + "img/instagram.9988a3c8.svg";